// pc-builder-payment-secure.js — v2.0
// SECURE Payment Integration - Now with quantity support

document.addEventListener('DOMContentLoaded', () => {
  initPaymentPage();
});

// ==================== INITIALIZATION ====================
function initPaymentPage() {
  const products = getStoredProducts();
  const total = getStoredTotal();

  console.log('🔍 Payment page init - Products:', products);
  console.log('🔍 Payment page init - Total:', total);

  if (products && products.length > 0) {
    console.log('✅ Products found, displaying...');
    displayProducts(products);
    displayTotal(total);
    setupEventListeners();
  } else {
    console.error('❌ No products found in sessionStorage!');
    showEmptyState();
  }
}

// ==================== EMPTY STATE ====================
function showEmptyState() {
  const container = document.getElementById('productsList');
  if (container) {
    container.innerHTML =
      '<div class="empty-state">' +
        '<svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="1.5">' +
          '<circle cx="9" cy="21" r="1"/>' +
          '<circle cx="20" cy="21" r="1"/>' +
          '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>' +
        '</svg>' +
        '<h3>No products in your build</h3>' +
        '<p>Please go back to the PC Builder to select your components.</p>' +
        '<a href="/pages/custom-build-pc" class="btn-primary" style="display: inline-flex; margin-top: 1rem;">' +
          'Back to Builder' +
        '</a>' +
      '</div>';
  }
}

// ==================== DATA RETRIEVAL ====================
function getStoredProducts() {
  try {
    var data = sessionStorage.getItem('pcBuilderProducts');
    return data ? JSON.parse(data) : null;
  } catch (e) {
    console.error('Error reading products from sessionStorage:', e);
    return null;
  }
}

function getStoredTotal() {
  return sessionStorage.getItem('pcBuilderTotal') || '0.00';
}

function displayProducts(products) {
  var container = document.getElementById('productsList');
  if (!container) return;

  var componentLabels = {
    'case': 'PC Case',
    'cpu': 'Processor (CPU)',
    'cooler': 'CPU Cooler',
    'motherboard': 'Motherboard',
    'ram': 'RAM',
    'gpu': 'Graphics Card',
    'psu': 'Power Supply',
    'ssd': 'Storage (SSD)',
    'fan': 'Fan',
    'monitor': 'Monitor',
    'mouse': 'Mouse',
    'keyboard': 'Keyboard',
    'headset': 'Headset'
  };

  var html = '';
  products.forEach(function(product) {
    var componentType = detectComponentType(product);
    var label = componentLabels[componentType] || componentType.toUpperCase();
    var qty = product.qty || 1;
    var unitPrice = product.priceRaw || 0;
    var subtotal = unitPrice * qty;

    html +=
      '<div class="product-item">' +
        '<div class="product-image">' +
          (product.image
            ? '<img src="' + product.image + '" alt="' + product.title + '">'
            : '<div class="no-image">' + componentType.toUpperCase() + '</div>'
          ) +
        '</div>' +
        '<div class="product-details">' +
          '<span class="product-category">' + label + '</span>' +
          '<h4 class="product-name">' + product.title + '</h4>' +
          (qty > 1
            ? '<span class="product-unit-price">@ ' + product.price + ' each</span>'
            : ''
          ) +
        '</div>' +
        '<div class="product-qty-price">' +
          (qty > 1
            ? '<span class="product-qty">×' + qty + '</span>'
            : ''
          ) +
          '<span class="product-price">RM ' + subtotal.toFixed(2) + '</span>' +
        '</div>' +
      '</div>';
  });

  container.innerHTML = html;
}

// Detect component type from product tags
function detectComponentType(product) {
  var tags = (product.tags || '').toLowerCase();
  var title = (product.title || '').toLowerCase();

  if (tags.includes('pc case') || tags.includes('case') || tags.includes('pc-case')) return 'case';
  if (tags.includes('processor') || tags.includes('cpu') || title.includes('processor')) return 'cpu';
  if (tags.includes('cpu cooler') || tags.includes('cooler') || tags.includes('cpu-cooler')) return 'cooler';
  if (tags.includes('motherboard') || title.includes('motherboard')) return 'motherboard';
  if (tags.includes('ram') || tags.includes('memory') || title.includes('ram')) return 'ram';
  if (tags.includes('graphics card') || tags.includes('gpu') || tags.includes('graphic') || title.includes('graphics')) return 'gpu';
  if (tags.includes('power supply') || tags.includes('psu') || title.includes('power supply')) return 'psu';
  if (tags.includes('storage') || tags.includes('ssd') || title.includes('ssd')) return 'ssd';
  if (tags.includes('fan') || title.includes('fan')) return 'fan';
  if (tags.includes('monitor') || title.includes('monitor')) return 'monitor';
  if (tags.includes('mouse') || title.includes('mouse')) return 'mouse';
  if (tags.includes('keyboard') || title.includes('keyboard')) return 'keyboard';
  if (tags.includes('headset') || title.includes('headset')) return 'headset';

  return 'component';
}

function displayTotal(total) {
  var subtotalEl = document.getElementById('subtotalAmount');
  var grandTotalEl = document.getElementById('grandTotalAmount');

  // Also show item count
  var products = getStoredProducts();
  if (products) {
    var totalItems = products.reduce(function(s, p) { return s + (p.qty || 1); }, 0);
    var uniqueCount = products.length;
    var itemCountEl = document.getElementById('itemCountDisplay');
    if (itemCountEl) {
      var countText = uniqueCount + ' component' + (uniqueCount !== 1 ? 's' : '');
      if (totalItems > uniqueCount) countText += ' (' + totalItems + ' items total)';
      itemCountEl.textContent = countText;
    }
  }

  if (subtotalEl) subtotalEl.textContent = 'RM ' + total;
  if (grandTotalEl) grandTotalEl.textContent = 'RM ' + total;
}

// ==================== EVENT LISTENERS ====================
function setupEventListeners() {
  var form = document.getElementById('customerForm');
  if (form) {
    form.addEventListener('submit', handleFormSubmit);
  }

  var paymentOptions = document.querySelectorAll('.payment-option');
  paymentOptions.forEach(function(option) {
    option.addEventListener('click', function() {
      var radio = option.querySelector('input[type="radio"]');
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  // Payment Method Selection Toggle (IPP & BNPL)
  var ippMonthsContainer = document.getElementById('ippMonthsContainer');
  var bnplProvidersContainer = document.getElementById('bnplProvidersContainer');
  var paymentMethodRadios = document.querySelectorAll('input[name="paymentMethod"]');

  paymentMethodRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      var total = getStoredTotal();
      displayTotal(total);

      if (radio.value === 'ipp' && radio.checked) {
        if (ippMonthsContainer) ippMonthsContainer.style.display = 'block';
        document.querySelectorAll('input[name="ippMonths"]').forEach(function(mr) { mr.required = true; });
        var ippCalc = document.getElementById('ippCalculation');
        if (ippCalc) ippCalc.style.display = 'none';

        if (bnplProvidersContainer) bnplProvidersContainer.style.display = 'none';
        document.querySelectorAll('input[name="bnplProvider"]').forEach(function(pr) {
          pr.required = false;
          pr.checked = false;
        });
        var bnplCalc = document.getElementById('bnplCalculation');
        if (bnplCalc) bnplCalc.style.display = 'none';
      } else if (radio.value === 'bnpl' && radio.checked) {
        if (bnplProvidersContainer) bnplProvidersContainer.style.display = 'block';
        document.querySelectorAll('input[name="bnplProvider"]').forEach(function(pr) { pr.required = true; });
        var bnplCalc2 = document.getElementById('bnplCalculation');
        if (bnplCalc2) bnplCalc2.style.display = 'none';

        if (ippMonthsContainer) ippMonthsContainer.style.display = 'none';
        document.querySelectorAll('input[name="ippMonths"]').forEach(function(mr) {
          mr.required = false;
          mr.checked = false;
        });
        var ippCalc2 = document.getElementById('ippCalculation');
        if (ippCalc2) ippCalc2.style.display = 'none';
      } else {
        if (ippMonthsContainer) ippMonthsContainer.style.display = 'none';
        document.querySelectorAll('input[name="ippMonths"]').forEach(function(mr) {
          mr.required = false;
          mr.checked = false;
        });
        var ippCalc3 = document.getElementById('ippCalculation');
        if (ippCalc3) ippCalc3.style.display = 'none';

        if (bnplProvidersContainer) bnplProvidersContainer.style.display = 'none';
        document.querySelectorAll('input[name="bnplProvider"]').forEach(function(pr) {
          pr.required = false;
          pr.checked = false;
        });
        var bnplCalc3 = document.getElementById('bnplCalculation');
        if (bnplCalc3) bnplCalc3.style.display = 'none';
      }
    });
  });

  // IPP Month Selection
  document.querySelectorAll('input[name="ippMonths"]').forEach(function(radio) {
    radio.addEventListener('change', function() {
      if (radio.checked) {
        calculateIPPTotal(radio.value, radio.dataset.fee);
      }
    });
  });

  // BNPL Provider Selection
  document.querySelectorAll('input[name="bnplProvider"]').forEach(function(radio) {
    radio.addEventListener('change', function() {
      if (radio.checked && !radio.disabled) {
        calculateBNPLTotal(radio.value, radio.dataset.fee);
      }
    });
  });

  // Phone number formatting
  var phoneInput = document.getElementById('phone');
  if (phoneInput) {
    phoneInput.addEventListener('input', function(e) { formatPhoneNumber(e.target); });
    phoneInput.addEventListener('blur', function(e) { formatPhoneNumber(e.target); });
  }
}

// ==================== IPP CALCULATION ====================
function calculateIPPTotal(months, feePercent) {
  var originalTotal = parseFloat(getStoredTotal());
  var feePercentNum = parseFloat(feePercent);

  var feeAmount = originalTotal * (feePercentNum / 100);
  var newTotal = originalTotal + feeAmount;
  var monthlyPayment = newTotal / parseInt(months);

  document.getElementById('ippOriginalTotal').textContent = 'RM ' + originalTotal.toFixed(2);
  document.getElementById('ippFeePercent').textContent = feePercentNum;
  document.getElementById('ippFeeAmount').textContent = 'RM ' + feeAmount.toFixed(2);
  document.getElementById('ippNewTotal').textContent = 'RM ' + newTotal.toFixed(2);
  document.getElementById('ippMonthlyPayment').textContent = 'RM ' + monthlyPayment.toFixed(2) + '/month';

  document.getElementById('ippCalculation').style.display = 'block';

  var grandTotalEl = document.getElementById('grandTotalAmount');
  if (grandTotalEl) grandTotalEl.textContent = 'RM ' + newTotal.toFixed(2);
}

// ==================== BNPL CALCULATION ====================
function calculateBNPLTotal(provider, feePercent) {
  var originalTotal = parseFloat(getStoredTotal());
  var feePercentNum = parseFloat(feePercent);

  var feeAmount = originalTotal * (feePercentNum / 100);
  var newTotal = originalTotal + feeAmount;

  document.getElementById('bnplOriginalTotal').textContent = 'RM ' + originalTotal.toFixed(2);
  document.getElementById('bnplFeePercent').textContent = feePercentNum;
  document.getElementById('bnplFeeAmount').textContent = 'RM ' + feeAmount.toFixed(2);
  document.getElementById('bnplNewTotal').textContent = 'RM ' + newTotal.toFixed(2);

  document.getElementById('bnplCalculation').style.display = 'block';

  var grandTotalEl = document.getElementById('grandTotalAmount');
  if (grandTotalEl) grandTotalEl.textContent = 'RM ' + newTotal.toFixed(2);
}

// ==================== PHONE NUMBER FORMATTING ====================
function formatPhoneNumber(input) {
  var value = input.value.replace(/\D/g, '');
  if (value.startsWith('60')) value = '0' + value.substring(2);
  if (value && !value.startsWith('0')) value = '0' + value;
  value = value.substring(0, 11);
  input.value = value;
  input.style.borderColor = (value.length >= 10 && value.length <= 11) ? '#00cc33' : '';
}

// ==================== FORM HANDLING ====================
async function handleFormSubmit(e) {
  e.preventDefault();

  var form = e.target;
  if (!form.checkValidity()) {
    form.reportValidity();
    return;
  }

  var selectedPayment = form.querySelector('input[name="paymentMethod"]:checked');
  if (!selectedPayment) {
    alert('Please select a payment method');
    return;
  }

  var total = getStoredTotal();

  if (selectedPayment.value === 'ipp') {
    var selectedMonth = form.querySelector('input[name="ippMonths"]:checked');
    if (!selectedMonth) {
      alert('Please select an instalment period (6, 12, 18, or 24 months)');
      return;
    }
    var origTotal = parseFloat(total);
    var fee = origTotal * (parseFloat(selectedMonth.dataset.fee) / 100);
    total = (origTotal + fee).toFixed(2);
  }

  if (selectedPayment.value === 'bnpl') {
    var selectedProvider = form.querySelector('input[name="bnplProvider"]:checked');
    if (!selectedProvider || selectedProvider.disabled) {
      alert('Please select a BNPL provider (SPayLater or GrabPay Later)');
      return;
    }
    var origTotal2 = parseFloat(total);
    var fee2 = origTotal2 * (parseFloat(selectedProvider.dataset.fee) / 100);
    total = (origTotal2 + fee2).toFixed(2);
  }

  showLoading();

  try {
    var products = getStoredProducts();
    if (!products || products.length === 0) throw new Error('No products found');

    var rawPhone = form.phone.value.trim();
    var phoneDigits = rawPhone.replace(/\D/g, '');
    if (!phoneDigits.startsWith('0') || phoneDigits.length < 10 || phoneDigits.length > 11) {
      hideLoading();
      alert('Invalid phone number format.\n\nPlease enter a Malaysian phone number:\n- Must start with 0\n- Must be 10-11 digits\n- Example: 0123456789');
      return;
    }

    var totalAmount = parseFloat(total);
    if (isNaN(totalAmount) || totalAmount <= 0) {
      hideLoading();
      alert('Invalid payment amount. Please refresh and try again.');
      return;
    }

    var customerInfo = {
      firstName: form.firstName.value.trim(),
      lastName: form.lastName.value.trim(),
      email: form.email.value.trim(),
      phone: phoneDigits,
      address1: form.address1.value.trim(),
      address2: form.address2.value.trim(),
      city: form.city.value.trim(),
      state: form.state.value,
      postcode: form.postcode.value.trim(),
      country: form.country.value,
      notes: form.notes.value.trim()
    };

    var orderId = generateOrderId();
    var productNames = products.map(function(p) {
      var qty = p.qty || 1;
      return p.title + (qty > 1 ? ' x' + qty : '');
    }).join(', ');
    var description = ('Custom PC Build: ' + productNames).substring(0, 200);

    var orderData = {
      orderId: orderId,
      products: products,
      total: total,
      customer: customerInfo,
      paymentMethod: selectedPayment.value,
      createdAt: new Date().toISOString()
    };

    if (selectedPayment.value === 'ipp') {
      var selMonth = form.querySelector('input[name="ippMonths"]:checked');
      orderData.ippMonths = selMonth.value;
      orderData.ippFeePercent = parseFloat(selMonth.dataset.fee);
      orderData.ippOriginalTotal = getStoredTotal();
      orderData.ippAdjustedTotal = total;
    }

    if (selectedPayment.value === 'bnpl') {
      var selProv = form.querySelector('input[name="bnplProvider"]:checked');
      orderData.bnplProvider = selProv.value;
      orderData.bnplFeePercent = parseFloat(selProv.dataset.fee);
      orderData.bnplOriginalTotal = getStoredTotal();
      orderData.bnplAdjustedTotal = total;
    }

    sessionStorage.setItem('pendingOrder', JSON.stringify(orderData));

    await processSenangpayPayment(orderId, total, customerInfo, description, selectedPayment.value);

  } catch (error) {
    console.error('Error processing payment:', error);
    hideLoading();
    alert('There was an error processing your payment. Please try again.\n\nError: ' + error.message);
  }
}

// ==================== SECURE SENANGPAY PAYMENT ====================
async function processSenangpayPayment(orderId, total, customer, description, paymentMethod) {
  try {
    var response = await fetch(window.PAYMENT_CONFIG.backendUrl + '/api/create-senangpay-payment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        orderId: orderId,
        amount: parseFloat(total).toFixed(2),
        customer: customer,
        productDescription: description,
        paymentMethod: paymentMethod
      })
    });

    if (!response.ok) {
      var errorData = await response.json().catch(function() { return { error: 'Unknown error' }; });
      throw new Error(errorData.error || 'Failed to create payment session');
    }

    var result = await response.json();

    if (result.success && result.paymentUrl && result.paymentData) {
      submitPaymentForm(result.paymentUrl, result.paymentData);
    } else {
      throw new Error('No payment URL returned from backend');
    }

  } catch (error) {
    hideLoading();
    throw error;
  }
}

// ==================== PAYMENT FORM SUBMISSION ====================
function submitPaymentForm(actionUrl, data) {
  var form = document.createElement('form');
  form.method = 'POST';
  form.action = actionUrl;
  form.style.display = 'none';

  for (var key in data) {
    if (data.hasOwnProperty(key) && data[key] !== undefined && data[key] !== null && data[key] !== '') {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = String(data[key]);
      form.appendChild(input);
    }
  }

  document.body.appendChild(form);
  form.submit();
}

// ==================== UTILITY FUNCTIONS ====================
function generateOrderId() {
  var now = new Date();
  var dateStr = now.getFullYear().toString() +
    (now.getMonth() + 1).toString().padStart(2, '0') +
    now.getDate().toString().padStart(2, '0');
  var timeStr = now.getHours().toString().padStart(2, '0') +
    now.getMinutes().toString().padStart(2, '0') +
    now.getSeconds().toString().padStart(2, '0');
  var random = Math.random().toString(36).substring(2, 6).toUpperCase();
  return 'PCB' + dateStr + timeStr + random;
}

function showLoading() {
  var overlay = document.getElementById('loadingOverlay');
  if (overlay) overlay.classList.add('active');
}

function hideLoading() {
  var overlay = document.getElementById('loadingOverlay');
  if (overlay) overlay.classList.remove('active');
}